import WebMap from '@arcgis/core/WebMap';
import GroupLayer from '@arcgis/core/layers/GroupLayer';

export const webmap = (id:string):WebMap=>{
    let map = new WebMap({portalItem:{id:id}})
    const operationalLayers = new GroupLayer({id:"operationalLayers",title:"Operational Layers"})
    map.when(map=>{
        map.addMany([operationalLayers],map.allLayers.length+1)
    })
    
    return map
};

// export const pubMap = webmap("e691172598f04ea8881cd2a4adaa45ba");
// export const privMap = webmap("c4580c8f45c746d4b3f502e20d2c4b11");
